import React, {PureComponent} from 'react';
import { Button, Modal, ModalBody , ModalHeader , ModalFooter} from 'reactstrap';
import ButtonLoaderAtom from 'atoms/ButtonLoader';
import styles from './styles.module.scss';

class DeleteTagModal extends PureComponent {

  render() {
    const {isOpen, toggle, deleteSelectedTags, isSubmitting} = this.props;
    return (
      <Modal isOpen={isOpen}>
        <ModalHeader toggle={()=>toggle()}>Delete Confirmation</ModalHeader>
        <ModalBody>
          <div className={styles.deleteTagModalbody}>Are you sure you want to delete the selected tag(s)?</div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="danger"
            onClick={() => deleteSelectedTags()}
          >
          Yes <ButtonLoaderAtom active={isSubmitting} />
          </Button>
          <Button color="secondary" onClick={()=>toggle()}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );}
  }
  
export default DeleteTagModal;